import { useContext } from 'react';

import { ConsentContext } from './CookieConsentProvider';

export const useCookieConsent = () => {
    const ctx = useContext(ConsentContext);
    if (!ctx) {
        throw new Error('useCookieConsent must be used within a CookieConsentProvider');
    }
    return ctx;
};
